// import React, { useState } from 'react';
// import axios from 'axios';
// import ImagePro from '../../../assets/images/PurpleIcon.png';
// import './app.css';
// import PopupCustomer from '../jobhistory/popupCustomerCom';
// import InvoicePopup from '../jobhistory/InvoicePopup';

// const TopCustomer = ({
//   ID,
//   Avatar,
//   name,
//   textpopupBtn,
//   Item,
//   spent,
//   onDeleteInoive,
//   Completed,
//   show,
//   vist,
// }) => {
//   const [modalShow, setModalShow] = useState(false);
//   const [invoiceShow, setInvoiceShow] = useState(false);
// console.log('Item',Item)
//   // IMPORTANT: array rakho
//   const [popupData, setPopupData] = useState([]);

//   const handleViewDocumentsClick = async () => {
//     const token = localStorage.getItem('accessTokenAdmin');

//     setModalShow(true);

//     try {
//       const response = await axios.get(
//         `https://production.washta.com/api/admin/orders?limit=5&customerId=${ID}`,
//         {
//           headers: {
//             Authorization: `Bearer ${token}`,
//           },
//         }
//       );

//       setPopupData(response?.data?.data || []);
//     } catch (error) {
//       console.error('Error fetching data:', error);
//       setPopupData([]);
//     }
//   };

//   const handleDeleteInvoice = async () => {
//     const token = localStorage.getItem('accessTokenAdmin');

//     try {
//       const response = await axios.delete(
//         `https://production.washta.com/api/admin/bookings/${onDeleteInoive}`,
//         {
//           headers: {
//             Authorization: `Bearer ${token}`,
//           },
//         }
//       );

//       if (response.status === 200) {
//         setModalShow(false);
//       } else {
//         alert('Failed to delete customer.');
//       }
//     } catch (err) {
//       console.error(err);
//       alert('Error deleting customer.');
//     }
//   };

//   const handleViewInvoice = () => {
//     setModalShow(false);
//     setInvoiceShow(true);
//   };

//   return (
//     <div className="tope-customer-com-main">
//       <div
//         className="second-row-customer"
//         style={{ cursor: 'pointer' }}
//         onClick={handleViewDocumentsClick}
//       >
//         <img
//           src={Avatar || ImagePro}
//           alt="customer"
//           className="image-pro-companies"
//           style={{
//             boxShadow: '0px 0px 3px 0px #333',
//             borderRadius: '21%',
//           }}
//         />

//         <div className="top-custorm-width">
//           <div className="flex justify-between items-center">
//             <h5 className="h5-class-top-class">{name || 'N/A'}</h5>

//             {Item?.isExpired && (
//               <h5 className="paragprh-customer-com text-red-600 bg-red-100 px-2 py-1 rounded-full mr-[-12px]">
//                 Expired
//               </h5>
//             )}
//           </div>

//           <p className="paragprh-customer-com">{vist || '-'}</p>
//         </div>
//       </div>

//       {show && (
//         <div
//           className="second-row-customer"
//           style={{ paddingTop: 16, cursor: 'pointer' }}
//           onClick={handleViewDocumentsClick}
//         >
//           <p className="paragprh-customer-com">Status</p>
//           <p className="heading-sub-customer-com">
//             {Completed || 'N/A'}
//           </p>
//         </div>
//       )}

//       {modalShow && (
//         <PopupCustomer
//         item ={Item}
//           customer={true}
//           onDeleteInoive={handleDeleteInvoice}
//           showBtn={true}
//           HandleLogout=""
//           show={modalShow}
//           onHide={() => setModalShow(false)}
//           popupData={popupData || []}
//           textpopupBtn={textpopupBtn}
//           onViewInvoice={handleViewInvoice}
//         />
//       )}

//       <InvoicePopup
//         customer={true}
//         showFields={false}
//         show={invoiceShow}
//         onClose={() => setInvoiceShow(false)}
//         invoiceData={Item || {}}
//       />

//       <div
//         className="second-row-customer"
//         style={{
//           paddingTop: show ? 5 : 15,
//           border: 'none',
//           cursor: 'pointer',
//         }}
//         onClick={handleViewDocumentsClick}
//       >
//         <p className="paragprh-customer-com">Total Spent</p>

//         <p className="heading-sub-customer-com">
//           {spent || 0} <span style={{ fontSize: 9 }}>AED</span>
//         </p>
//       </div>
//     </div>
//   );
// };

// export default TopCustomer;
import React, { useState } from 'react';
import axios from 'axios';
import ImagePro from '../../../assets/images/PurpleIcon.png';
import './app.css';
import PopupCustomer from '../jobhistory/popupCustomerCom';
import InvoicePopup from '../jobhistory/InvoicePopup';

const TopCustomer = ({
  ID,
  Avatar,
  name,
  textpopupBtn,
  Item,
  spent,
  onDeleteInoive,
  Completed,
  show,
  vist,
}) => {
  const [modalShow, setModalShow] = useState(false);
  const [invoiceShow, setInvoiceShow] = useState(false);

  // IMPORTANT: array rakho (sirf sidebar/history ke liye backup)
  const [popupData, setPopupData] = useState([]);

  const handleViewDocumentsClick = async () => {
    const token = localStorage.getItem('accessTokenAdmin');

    // Pehle modal open karo taake user ko wait na lagey
    setModalShow(true);

    try {
      const response = await axios.get(
        `https://production.washta.com/api/admin/orders?limit=5&customerId=${ID}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      setPopupData(response?.data?.data || []);
    } catch (error) {
      console.error('Error fetching data:', error);
      setPopupData([]);
    }
  };

  const handleDeleteInvoice = async () => {
    const token = localStorage.getItem('accessTokenAdmin');

    try {
      const response = await axios.delete(
        `https://production.washta.com/api/admin/bookings/${onDeleteInoive}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      if (response.status === 200) {
        setModalShow(false);
      } else {
        alert('Failed to delete customer.');
      }
    } catch (err) {
      console.error(err);
      alert('Error deleting customer.');
    }
  };

  const handleViewInvoice = () => {
    setModalShow(false);
    setInvoiceShow(true);
  };

  return (
    <div className="tope-customer-com-main">
      <div
        className="second-row-customer"
        style={{ cursor: 'pointer' }}
        onClick={handleViewDocumentsClick}
      >
        <img
          src={Avatar || ImagePro}
          alt="customer"
          className="image-pro-companies"
          style={{
            boxShadow: '0px 0px 3px 0px #333',
            borderRadius: '21%',
          }}
        />

        <div className="top-custorm-width">
          <div className="flex justify-between items-center">
            <h5 className="h5-class-top-class">{name || 'N/A'}</h5>

            {Item?.isExpired && (
              <h5 className="paragprh-customer-com text-red-600 bg-red-100 px-2 py-1 rounded-full mr-[-12px]">
                Expired
              </h5>
            )}
          </div>

          <p className="paragprh-customer-com">{vist || '-'}</p>
        </div>
      </div>

      {show && (
        <div
          className="second-row-customer"
          style={{ paddingTop: 16, cursor: 'pointer' }}
          onClick={handleViewDocumentsClick}
        >
          <p className="paragprh-customer-com">Status</p>
          <p className="heading-sub-customer-com">
            {Completed || 'N/A'}
          </p>
        </div>
      )}

      {modalShow && (
        <PopupCustomer
          item={Item}           // ✅ clicked card ka apna data
          customer={true}
          onDeleteInoive={handleDeleteInvoice}
          showBtn={true}
          HandleLogout=""
          show={modalShow}
          onHide={() => setModalShow(false)}
          popupData={popupData || []}   // backup (sidebar history)
          textpopupBtn={textpopupBtn}
          onViewInvoice={handleViewInvoice}
        />
      )}

      {/* ✅ InvoicePopup ko bhi Item pass karo taake sahi invoice dikhe */}
      <InvoicePopup
        customer={true}
        showFields={false}
        show={invoiceShow}
        onClose={() => setInvoiceShow(false)}
        invoiceData={Item || {}}   // ✅ clicked card ka data
      />

      <div
        className="second-row-customer"
        style={{
          paddingTop: show ? 5 : 15,
          border: 'none',
          cursor: 'pointer',
        }}
        onClick={handleViewDocumentsClick}
      >
        <p className="paragprh-customer-com">Total Spent</p>

        <p className="heading-sub-customer-com">
          {spent || 0} <span style={{ fontSize: 9 }}>AED</span>
        </p>
      </div>
    </div>
  );
};

export default TopCustomer;